import { takeUntil } from 'rxjs/operators';
import { SessionService } from 'app/store/services/session.service';
import { setMessagesList } from '../../store/actions/message.action';
import { Store } from '@ngrx/store';
import { Button, ButtonColor, ButtonSize } from 'app/store/models/button.model';
import { LeftMenuService } from 'app/store/services/left-menu.service';
import { Router } from '@angular/router';
import { IFollowUp } from '../../store/models/follow_up.model';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ETableColumnType, ITableColumn, ITableDataSource,ITableFIlterGroup,EFilterType } from 'app/store/models/table.model';
import { HttpClient } from '@angular/common/http';
import { ApiDataSource } from 'app/datasources/api.datasrouce';
import { IReducers } from 'app/store/reducers';
import { Subject } from 'rxjs';
import { IUserSessionData, UserType } from 'app/store/models/user.model';
import { openDialog } from 'app/store/actions/page.action';
import { InfoTipsComponent } from 'app/dialogs/info-tips/info-tips.component';
import { environment } from '../../../environments/environment';
import { ContactsService } from 'app/store/services/contacts.service';
import { ResponsesService } from 'app/store/services/responses.service';

import { QrEditComponent } from 'app/dialogs/qr-edit/qr-edit.component';
import { DialogComponent } from 'app/shared/ui/dialog/dialog.component';

@Component({
  selector: 'app-follow-ups-listing',
  templateUrl: './follow-ups-listing.component.html',
  styleUrls: ['./follow-ups-listing.component.scss'],
})
export class FollowUpsListingComponent implements OnInit, OnDestroy {
  tableDataSourceParams = {
    page: 1,
    pageSize: 10,
    sortAttr: 'action_data1',
    sortDir: 'desc',
    filters: {},
  };

   tableFilterGroups: ITableFIlterGroup[] = [
      {
        filters: [
          {
            type: EFilterType.SEARCH,
            label: 'Search',
            items: [
              {
                id: 'search',
                label: 'Search...',
              },
            ],
          },
        ]
      }
    ];

  tableColumns: ITableColumn<IFollowUp>[];
  dataSource: ApiDataSource<IFollowUp>;
  exportButtonProperties: Button = {
    onClick: () => {},
    size: ButtonSize.SMALL,
    text: 'Export',
    color: ButtonColor.ORANGE,
  };
  tableReady: boolean;
  showExportButton: boolean;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  private popupShown: boolean;
  private sessionData: IUserSessionData;

  constructor(
    private http: HttpClient,
    private router: Router,
    private leftMenu: LeftMenuService,
    private store: Store<IReducers>,
    private sessionService: SessionService,
    private contactsService: ContactsService,
    private responsesService: ResponsesService,
  ) {
    this.dataSource = new ApiDataSource<IFollowUp>(
      this.http,
      environment.apiUrl + '/v1/messages/followup',
    );
    this.exportButtonProperties.onClick = () =>
      this.contactsService.getExport('followup').subscribe((response: Blob) => {
        const dataType = response.type;
        const binaryData = [];
        binaryData.push(response);
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(
          new Blob(binaryData, { type: dataType }),
        );

        downloadLink.setAttribute('download', 'followup.csv');
        document.body.appendChild(downloadLink);
        downloadLink.click();
      });
    this.leftMenu.expand('inbox');
  }

  rowClass = () => ['route_message'];

  ngOnInit() {
    this.sessionService
      .onReady()
      .pipe(takeUntil(this.destroy$))
      .subscribe(sessionData => {
        this.sessionData = sessionData;
        if (sessionData.user_type !== UserType.MASTER) {
          this.showExportButton = true;
        }
        if (sessionData.popup_tips) {
          if (this.popupShown) {
            return;
          }

          this.popupShown = true;
          this.store.dispatch(
            openDialog({
              dialogData: {
                content: InfoTipsComponent,
                title: 'Tips',
                canClose: true,
                dialogMinWidth: '700px',
                componentData: {
                  type: 'followup_popup',
                },
              },
            }),
          );
        }
        const columns: ITableColumn<IFollowUp>[] = [
          {
            id: 'contact_firstname',
            title: 'Contact',
            sortable: true,
            renderer: row => {
              return `${row.contact_firstname ? row.contact_firstname : ''} ${
                row.contact_lastname ? row.contact_lastname : ''
              }`;
            },
            route: row => this.onColumnClick(row),
          },
          {
            id: 'contact_company',
            title: 'Company',
            sortable: true,
            route: row => this.onColumnClick(row),
          },
          {
            id: 'action_date',
            title: 'Follow Up Date',
            sortable: true,
            route: row => this.onColumnClick(row),
            isDateColumn: true,
            dateFormat: 'MM/DD/YYYY',
          },
          {
            id: 'action_status',
            title: 'Status',
            route: row => this.editDialog(row),
          },
          {
            id: 'next_email_at',
            title: 'Next Scheduled Date',
            sortable: true,
            defaultSorted: true,
            route: row => this.onColumnClick(row),
            isDateColumn: true,
            dateFormat: 'MM/DD/YYYY',
            emptyValue: 'Scheduled',
          },
        ];

        if (sessionData.user_type !== UserType.SINGLE_USER) {
          columns.push({
            id: 'account_firstname',
            title:
              sessionData.user_type === UserType.MASTER
                ? 'Account'
                : 'Representative',
            sortable: true,
            renderer: row => {
              return `${row.account_firstname} ${row.account_lastname}`;
            },
            route: row => this.onColumnClick(row),
          });

          if (sessionData.user_type === UserType.MASTER) {
            columns.push({
              id: 'export',
              title: 'Export',
              type: ETableColumnType.BUTTON,
              buttonProperties: {
                color: ButtonColor.ORANGE,
                text: 'Export',
                size: ButtonSize.NORMAL,
                onClick: (row: IFollowUp) => {
                  this.contactsService.getExport('followup', row.account_id).subscribe((response: Blob) => {
                    const dataType = response.type;
                    const binaryData = [];
                    binaryData.push(response);
                    const downloadLink = document.createElement('a');
                    downloadLink.href = window.URL.createObjectURL(
                      new Blob(binaryData, { type: dataType }),
                    );

                    downloadLink.setAttribute('download', 'followup.csv');
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                  });
                },
              },
            });
          }
        }

        // @see https://app.asana.com/0/home/1122119018347786/1207192068396695
        // if (sessionData.user_type === UserType.MASTER) {
        //   columns.push({
        //     id: 'follow_reply',
        //     title: 'Indicator',
        //     type: ETableColumnType.CHECKBOX,
        //     checkboxProperties: {
        //       label: 'Replay',
        //       disabled: true,
        //     },
        //   });
        // }

        this.tableColumns = columns;
        this.tableReady = true;
      });
  }

  ngOnDestroy() {
    this.destroy$.next(false);
  }

  onColumnClick(item: IFollowUp) {
    this.router.navigate([
      '/messages/view',
      item.message_id,
      {
        from: 'follow_up',
      },
    ]);
  }

  onData = (items: IFollowUp[]) => {
    this.store.dispatch(
      setMessagesList({ list: items.map(item => item.message_id) }),
    );
  };

  editDialog(row) {
    if(this.sessionData.user_type !== UserType.SINGLE_USER) {
      return;
    }
    this.store.dispatch(
      openDialog({
        dialogData: {
          title: `Update follow up message for ${row.contact_firstname} ${row.contact_lastname}`,
          content: QrEditComponent,
          componentData: {
            data: {
              row,
              type: 'cycle',
            },
          },
          dialogMinWidth: '1000px',
          canClose: true,
          buttons: [
            {
              text: 'Update',
              actAsClose: true,
              color: ButtonColor.ORANGE,
              size: ButtonSize.NORMAL,
              onClick: (dialog: DialogComponent) => {
                if (dialog.dialogForm.valid) {
                  this.dialogSubmit(dialog.dialogForm, row);
                }
              },
            },
          ],
        },
      }),
    );
  }

  dialogSubmit(form, row) {
    const data = form.getRawValue();
    this.responsesService
      .updateAction(row.action_id, data)
      .subscribe(response => {
        console.log(response);
      });
  }
}
